<svg width="180" height="180" version="1.1" viewBox="0 0 47.6 47.6" xmlns="http://www.w3.org/2000/svg">
 <text x="23.538776" y="26.320419" fill="currentColor" font-family="Sans" font-size="7.06px" stroke="currentColor" stroke-width=".265" text-anchor="middle" xml:space="preserve">PDF</text>
</svg>
